import React from 'react';
import styled from 'styled-components';
import { Container } from '../styles/components';
import Logo from './Logo';
import CTAButton from './CTAButton';
import { useNavigate } from 'react-router-dom';

const HeaderWrapper = styled.header`
  padding: 32px 0;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  transition: background-color 0.5s ease, box-shadow 0.3s ease;
  background-color: ${props => {
    if (props.$isDark) {
      return props.theme.colors.charcoal;
    }
    return props.theme.colors.bone;
  }};
  box-shadow: none;
`;

const HeaderContainer = styled(Container)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  max-width: ${props => props.theme.spacing.maxWidth};
  margin: 0 auto;
  padding: 0 ${props => props.theme.spacing.xxl};

  @media (max-width: ${props => props.theme.breakpoints.mobile}) {
    padding-left: ${props => props.theme.spacing.md} !important;
    padding-right: ${props => props.theme.spacing.md} !important;
  }
`;

const LogoLink = styled.a`
  display: flex;
  align-items: center;
  text-decoration: none;

  @media (max-width: ${props => props.theme.breakpoints.mobile}) {
    & > div {
      width: 80%;
    }
  }
`;

const Nav = styled.nav`
  display: flex;
  align-items: center;
  gap: ${props => props.theme.spacing.md};

  @media (max-width: ${props => props.theme.breakpoints.tablet}) {
    gap: ${props => props.theme.spacing.sm};
  }

  @media (max-width: ${props => props.theme.breakpoints.mobile}) {
    button {
      padding: 8px 16px;
      font-size: 0.85rem;
    }
  }
`;

const Header = ({ isDark = true }) => {
  const navigate = useNavigate();

  const handleBookCallClick = () => {
    // Open Calendly popup widget
    if (window.Calendly) {
      window.Calendly.initPopupWidget({
        url: 'https://calendly.com/ellierofe/intro-chat?hide_event_type_details=1&hide_gdpr_banner=1&text_color=231f20&primary_color=c8553d'
      });
    }
  };



  return (
    <HeaderWrapper $isDark={isDark}>
      <HeaderContainer>
        <LogoLink href="/">
          <div className="logo-wrapper">
            <Logo size="60px" reversed={isDark} />
          </div>
        </LogoLink>
        <Nav>
          <CTAButton
            onClick={() => navigate('/assess-my-deck')}
            type="button"
            $isDark={isDark}
            secondary={true}
          >
            Assess My Deck (Beta)
          </CTAButton>
          <CTAButton
            onClick={handleBookCallClick}
            type="button"
            $isDark={isDark}
          >
            Book a strategy call
          </CTAButton>
        </Nav>
      </HeaderContainer>
    </HeaderWrapper>
  );
};

export default Header; 